import * as Styled from './styled';
import { Props } from './types';

function Chip({ type, children, ...props }: Props) {
  return (
    <Styled.Chip $type={type} role="status" {...props}>
      {children}
    </Styled.Chip>
  );
}

export default Chip;
